import { render, staticRenderFns } from "./SelectDisease.vue?vue&type=template&id=32760e5a&scoped=true"
import script from "./SelectDisease.vue?vue&type=script&lang=js"
export * from "./SelectDisease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32760e5a",
  null
  
)

export default component.exports